import AbstractObserver from './abstract';

export default class HeaderStickyObserver extends AbstractObserver {
  constructor(element) {
    super(element);
    this.dataSettings = this.element.hasAttribute('data-ua-header-options')
      ? JSON.parse(this.element.getAttribute('data-ua-header-options'))
      : {};
  }

  init() {
    this.defaultState = true;
    this.offset = this.element.offsetTop;

    return this;
  }

  destroy() {
    this.toDefaultState();

    return this;
  }

  check() {
    const docScrolled = window.scrollY;

    if (docScrolled > this.offset && this.defaultState) {
      this.changeState();
    } else if (docScrolled <= this.offset && !this.defaultState) {
      this.toDefaultState();
    }

    return this;
  }

  changeState() {
    this.toggleStateClasses('add', 'remove');
    this.defaultState = !this.defaultState;

    return this;
  }

  toDefaultState() {
    this.toggleStateClasses('remove', 'add');
    this.defaultState = !this.defaultState;

    return this;
  }

  toggleStateClasses(actionAdd, actionRemove) {
    this.element.classList[actionAdd]('navbar-scrolled');
    this.element.classList[actionAdd](this.dataSettings.fixMomentClasses);
    this.element.classList[actionRemove](this.dataSettings.fixMomentExclude);
  }
}
